// import "./App.less";
import { useEffect, useState } from "react";
// import UserRoute from "./User/Routes";
// import AdminRoute from "./Admin/Routes";
// import RoleRoute from "./Role/Routes";
import GlobalRoute from "./Global/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changingTokenAction } from "./store/action/shared/authAction";
import { langaugeTanslatorAction } from "./store/action/admin/languageTranslatorActions";

import { css } from "@emotion/css";
import { ThemeProvider } from "./Global/Settings/Component/ThemeProvider";
import {
  themeAction,
  themeCreateAction,
} from "./store/action/admin/themeActions";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import weekday from "dayjs/plugin/weekday";
import { initialTheme } from "./store/reducer/admin/themeReducer";
import isoWeek from "dayjs/plugin/isoWeek";
import updateLocale from "dayjs/plugin/updateLocale";
import localeData from "dayjs/plugin/localeData";
import en_GB from "dayjs/locale/en-gb";
import ErrorNoConnection from "./Global/Components/errorpage/errorNoConnection";
import ErrorBoundary from "./shared-components/ErrorBoundary";
import { ConfigProvider } from "antd";
import { socket } from "./shared-components/SocketConnection"; // Ensure correct path
import {
  getAllowedAppsAction,
  getCompanyAppsAction,
} from "./store/action/admin/companyAction";
import { serviceLinks } from "./Global/Components/dashboard";
// import { getFcmToken } from "./shared-components/push-notification";

dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
// Extend dayjs with the plugins
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isoWeek);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
// Extend dayjs with the plugins

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://24ccf9ee83944cde9a40addd128392d2@o1269615.ingest.sentry.io/6459778",
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
// });
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

// if (process.env.REACT_APP_SENTRY_ALLOWED === "true") {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_DSN,
//     integrations: [new BrowserTracing()],
//     tracesSampleRate: 1.0,
//   });
// }
// import { css } from "@emotion/css";
function App() {
  const origin = window.location.origin ? window.location.host : "";
  // const [username, setUsername] = useState("");
  const dispatch = useDispatch();

  const changingTokenList = useSelector((state) => state.changingTokenList);
  const { tokenLoginLoading } = changingTokenList;

  // const getLanguageTranslatorList = useSelector(
  //   (state) => state.getLanguageTranslatorList
  // );
  // const { translations } = getLanguageTranslatorList;
  const themeDefault = useSelector((state) => state.themeDefault);
  const themeCreateList = useSelector((state) => state.themeCreateList);
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const getCompanyAppsList = useSelector((state) => state.getCompanyAppsList);
  const { companyApps, companyAppsloading } = getCompanyAppsList;

  const getAllowedAppsList = useSelector((state) => state.getAllowedAppsList);
  const { allowedApps, allowedAppsloading } = getAllowedAppsList;
  const { sharedUserInfo } = sharedLogin;
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const storedToken =
          JSON.parse(localStorage.getItem("sharedUserInfo")) ||
          sharedUserInfo?.payload?.token;
        const browserToken = JSON.parse(localStorage.getItem("browserToken"));
        if (storedToken) {
          // const fcmToken = await getFcmToken();

          const tokenValue = storedToken?.payload?.token || storedToken;
          const payload = await dispatch(
            changingTokenAction(tokenValue, "", browserToken)
          );
          if (payload?.defaultApp) {
            const app = serviceLinks(payload).find(
              (app) => app.name === payload?.defaultApp
            );
            if (app) {
              window.location.href = app.href;
            }
          }
          // Fetch theme and language in parallel
          const [themeData] = await Promise.all([dispatch(themeAction())]);

          dispatch(langaugeTanslatorAction(themeData?.language || "en"));
          let compApps = companyApps;
          if (!compApps) {
            compApps = await dispatch(getCompanyAppsAction());
          }
          // let allowApps = allowedApps;
          // if (!allowApps) {
          //   console.log("run");
          //   allowApps = await dispatch(getAllowedAppsAction());
          // }
          console.log({ compApps });
          if (
            compApps &&
            (Object.keys(compApps).length === 0 ||
              Object.values(compApps).every((value) => !value))
          ) {
            window.location.href = process.env.REACT_APP_FE_HR_URL;
          } else {
            // const trueKeys = Object.keys(compApps).filter(
            //   (key) => compApps[key] && allowApps.includes(key)
            // );
            // if (trueKeys.length === 1 && allowApps.includes(trueKeys[0])) {
            //   const service = serviceLinks(payload).find(
            //     (link) => link.name === trueKeys[0]
            //   );
            //   if (service) {
            //     window.location.href = service.href;
            //   }
            // } else if (allowApps.length === 1) {
            //   const service = serviceLinks(payload).find(
            //     (link) => link.name === allowApps[0]
            //   );
            //   if (service) {
            //     window.location.href = service.href;
            //   }
            // }
          }
          setLoading(false);
        } else {
          setLoading(false);

          const themeData = await dispatch(themeAction(true));
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
      } catch (err) {
        setLoading(false);

        // console.error("Error during fetchData:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  let userType = "noUser";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  // Listen to online/offline events
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    const handleNotification = ({
      app,
      notification,
      browserToken,
      logoutApp,
    }) => {
      if (
        app === "auth" &&
        notification === "logout-one-browser" &&
        browserToken === JSON.parse(localStorage.getItem("browserToken")) &&
        logoutApp !== "auth"
      ) {
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    // Set up notification listener
    socket.on("notification", handleNotification);

    // Clean up function to remove event listener
    return () => {
      socket.off("notification", handleNotification);
    };
  }, []);

  // console.log({ userType });
  return (
    <>
      {/* <MyComponentWithDynamicImage
        dynamicImageUrl={`https://scontent.fkhi2-2.fna.fbcdn.net/v/t39.30808-1/400267919_1853787838371523_3840420261189620969_n.jpg?stp=dst-jpg_s200x200&_nc_cat=101&ccb=1-7&_nc_sid=5740b7&_nc_eui2=AeEHNWe4ogOYg8JR2l6FWBSrrcUjHXyO5PutxSMdfI7k-87UPOjwgMKnFsH6bpNvq7uaaca0cQkByfIxPY68VUY2&_nc_ohc=GpJ1xUy7QW4AX_-jz-r&_nc_ht=scontent.fkhi2-2.fna&oh=00_AfACjFnZ0DctYkOCJGRu8-zvQB9LYcghxeQU-XTnAvwWXw&oe=6584904E`}
        title={`${username}`}
      /> */}
      {/* <ResponsiveError /> */}
      <div
        className={css`
          height: 100vh;
        `}
      >
        <ConfigProvider locale={en_GB}>
          <ThemeProvider>
            {loading ||
            tokenLoginLoading ||
            (themeDefault?.info?.status &&
              themeDefault?.info?.status === "loading") ||
            !themeDefault?.info?.newConfig ? (
              <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <img src="/Loader1.gif" height="60%" />
              </div>
            ) : (
              <div
              // className={allCss}
              >
                {/* <ConfigProvider
                locale={translations?.antdLanguage}
                direction={
                  translations && translations?.direction
                    ? translations?.direction
                    : "ltr"
                }
              > */}
                <Router basename="/">
                  {/* <ManagerRoute /> */}
                  {!isOnline ? (
                    <ErrorNoConnection userType={userType} />
                  ) : (
                    <>
                      {/* <ErrorBoundary> */}
                      <GlobalRoute />
                      {/* {userType && userType.toLowerCase() === "admin" ? ( */}
                      {/* <AdminRoute />
                        {/* ) : userType && userType.toLowerCase() === "user" ? ( */}
                      {/* <UserRoute />
                    {/* ) : ( */}
                      {/* <RoleRoute /> */}
                      {/* )} */}
                      {/* </ErrorBoundary> */}
                    </>
                  )}
                </Router>
                {/* </ConfigProvider> */}
              </div>
            )}
          </ThemeProvider>
        </ConfigProvider>
      </div>
    </>
  );
}

export default App;
